import { render, staticRenderFns } from "./UploadFiles1.vue?vue&type=template&id=3b85d943&scoped=true"
import script from "./UploadFiles1.vue?vue&type=script&lang=js"
export * from "./UploadFiles1.vue?vue&type=script&lang=js"
import style0 from "./UploadFiles1.vue?vue&type=style&index=0&id=3b85d943&prod&lang=scss"
import style1 from "./UploadFiles1.vue?vue&type=style&index=1&id=3b85d943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85d943",
  null
  
)

export default component.exports